import { render, staticRenderFns } from "./WxReg.vue?vue&type=template&id=2dacd969&scoped=true"
import script from "./WxReg.vue?vue&type=script&lang=ts"
export * from "./WxReg.vue?vue&type=script&lang=ts"
import style0 from "./WxReg.vue?vue&type=style&index=0&id=2dacd969&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dacd969",
  null
  
)

export default component.exports